import axios from 'axios';
import { UploadFilesResponse } from '../hooks/useUploadFiles';
import axiosInstance from '../config/axios';


export class FileService {

    static async uploadFiles(files: File[]): Promise<UploadFilesResponse> {
        try {
            const formData = new FormData();
            files.forEach((file) => {
                formData.append('files', file);
            });

            const response = await axiosInstance.post<UploadFilesResponse>('/file/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error uploading files:', error);
            throw error; // Add this line to rethrow the error
        }
    }

}